/**
 * Validates JSON input for the rule testing paste-JSON mode.
 *
 * @param {string} input - Raw text from the JSON input panel.
 * @returns {{ valid: boolean, error: string|null, data: object|null }}
 */
export const validateJsonInput = (input) => {
  // Empty check
  if (!input || input.trim() === '') {
    return { valid: false, error: 'JSON input is required', data: null };
  }

  // Size check (> 1 MB via Blob)
  const sizeInBytes = new Blob([input]).size;
  const ONE_MB = 1024 * 1024;
  if (sizeInBytes > ONE_MB) {
    return { valid: false, error: 'JSON payload exceeds 1 MB size limit', data: null };
  }

  // JSON.parse attempt
  let parsed;
  try {
    parsed = JSON.parse(input);
  } catch (e) {
    return { valid: false, error: `Invalid JSON: ${e.message}`, data: null };
  }

  // Type check — must be non-null object, not array
  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return {
      valid: false,
      error: 'Input must be a JSON object (not array, string, or number)',
      data: null,
    };
  }

  // Empty object check
  if (Object.keys(parsed).length === 0) {
    return { valid: false, error: 'JSON object must contain at least one field', data: null };
  }

  return { valid: true, error: null, data: parsed };
};
